export const isJsonString = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const NAMED_ENTITIES: Record<string, string> = {
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  amp: '&',
};

const MAX_CODE_POINT = 0x10ffff; // highest code point Unicode defines; fromCodePoint throws above this
const MIN_SURROGATE_CODE_POINT = 0xd800; // start of the UTF-16 surrogate range, never a real standalone character
const MAX_SURROGATE_CODE_POINT = 0xdfff; // end of the UTF-16 surrogate range, never a real standalone character

const decodeEntity = (match: string, token: string): string => {
  const lower = token.toLowerCase();

  if (lower in NAMED_ENTITIES) {
    return NAMED_ENTITIES[lower];
  }

  const codePoint = lower.startsWith('#x')
    ? parseInt(lower.slice(2), 16)
    : Number(lower.slice(1));

  if (
    !Number.isInteger(codePoint) ||
    codePoint > MAX_CODE_POINT ||
    (codePoint >= MIN_SURROGATE_CODE_POINT &&
      codePoint <= MAX_SURROGATE_CODE_POINT)
  ) {
    return match;
  }

  return String.fromCodePoint(codePoint);
};

const decodeHtmlEntities = (value: string): string =>
  value.replace(
    /&(#x[0-9a-f]+|#\d+|lt|gt|quot|apos|nbsp|amp);/gi,
    decodeEntity
  );

export const parseToPlainText = (value: string | null | undefined): string => {
  if (value) {
    try {
      const isJson = isJsonString(value);
      let parsedValue = value;

      if (isJson) {
        parsedValue = JSON.parse(value);
      }

      return decodeHtmlEntities(parsedValue.replace(/(<([^>]+)>)/gi, ''));
    } catch (error) {
      return '';
    }
  }

  return '';
};

export const parseForInnerHTML = (value: string | null | undefined): string => {
  if (value) {
    const isJson = isJsonString(value);
    let parsedValue = value;

    if (isJson) {
      parsedValue = JSON.parse(value);
    }

    return parsedValue;
  }

  return '';
};

// same as the function above with the addition of applying empty lines inside the 'if'
export const parseForInnerHTMLWithBreaks = (
  value: string | null | undefined
): string => {
  if (value) {
    const isJson = isJsonString(value);
    let parsedValue = value;

    if (isJson) {
      parsedValue = JSON.parse(value);
    }

    // Ensure parsedValue is always a string before calling replace
    const stringValue = String(parsedValue);

    // Replace newlines with <br> tags
    const textWithBreaks = stringValue.replace(/\n/g, '<br>');
    // Replace multiple spaces with non-breaking spaces
    const textWithSpaces = textWithBreaks.replace(/  +/g, '&nbsp;&nbsp;');

    return textWithSpaces;
  }

  return '';
};
